import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'

import * as tutorialActions from '../tutorial.actions'

const TutorialCreateDebateMessageScreen = ({ removeScreen }) => (
  <div className="tutorial--response" style={{ zIndex: '1000' }}>
    <h1 className="h1">
      <FormattedMessage id="tutorial.turn2.academy_text.title" />
    </h1>
    <p>
      <FormattedMessage id="tutorial.turn2.academy_text.p1" />
    </p>
    <p>
      <FormattedMessage id="tutorial.turn2.academy_text.p2" />
    </p>
    <p>
      <FormattedMessage id="tutorial.turn2.academy_text.p3" />
      <b>
        <FormattedMessage id="tutorial.turn2.academy_text.p3_end" />
      </b>
    </p>

    <div className="btn--orange" onClick={() => removeScreen('create_debate_message_screen')}>
      <span className="icon-rocket"></span>
      <span>
        <FormattedMessage id="tutorial.common_texts.start" />
      </span>
    </div>
  </div>
)

const mapDispatchToProps = (dispatch) => ({
  removeScreen: bindActionCreators(tutorialActions.removeScreen, dispatch),
})

TutorialCreateDebateMessageScreen.propTypes = {
  removeScreen: PropTypes.func,
}

export default connect(null, mapDispatchToProps)(injectIntl(TutorialCreateDebateMessageScreen))
